import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import HashiCorpVaultRadarMappingForm from './HashiCorpVaultRadarMappingForm';
import HashiCorpVaultRadarCredentialsForm from './HashiCorpVaultRadarCredentialsForm';

const HashiCorpVaultRadarConfigListing = (props) => (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={HashiCorpVaultRadarMappingForm}
        CredentialsForm={HashiCorpVaultRadarCredentialsForm}
        componentName="Project"
        componentKey="projectName"
     />
);

export default HashiCorpVaultRadarConfigListing;
